// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__3Aa9I","textPrimary":"Text_textPrimary__1I-22","textLight":"Text_textLight__3k3Zp","textDark":"Text_textDark__3Hdb6","shadow":"Text_shadow__1HM7R"};